module.exports = __webpack_public_path__ + "img/allow-up.23e86fb0.svg";